import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { resetStateAction } from './actions/resetState';
import { authApi } from './auth';
import { neoMainApi, neoCognitoApi } from './neo';
import { neoServersApi } from './neoServers';
import { runApi } from './run/api';
import { teamApi } from './team/api';
import { reportApi } from './reports/api';
import { magnumApi } from './magnum/api';
import { jenkinsApi } from './jenkins';
import { requestApi } from './request/api';
import { versionApi } from './version/api';
import { userInfoApi } from './user_info';
import { artefactApi } from './artefacts/api';
import { advancedReportApi } from './advancedReports/api';
import { addNotification } from '../components/notications/notification.slice';
import {
    ACCESS_TOKEN,
    USER_DATA_STORAGE_ID,
    NEO_ACCESSES_STORAGE_ID,
    NEO_SERVER_STORAGE_ID,
    NEO_SERVER_ACCESS_STORAGE_ID,
    routerBasename,
} from '../config';

export const history = createBrowserHistory({ basename: routerBasename });

const unauthenticatedMiddleware: Middleware =
    ({ dispatch }) =>
    (next) =>
    (action) => {
        if (isRejectedWithValue(action) && action.payload.status === 401) {
            localStorage.removeItem(ACCESS_TOKEN);
            localStorage.removeItem(USER_DATA_STORAGE_ID);
            localStorage.removeItem(NEO_ACCESSES_STORAGE_ID);
            // The per-server map holds NEO group tokens and admin tokens. It
            // must go with the session, or the next user to log in on this
            // browser inherits the previous user's NEO access.
            localStorage.removeItem(NEO_SERVER_ACCESS_STORAGE_ID);
            localStorage.removeItem(NEO_SERVER_STORAGE_ID);

            dispatch(resetStateAction());
        }

        return next(action);
    };

export const rtkQueryErrorLogger: Middleware =
    ({ dispatch }) =>
    (next) =>
    (action) => {
        if (isRejectedWithValue(action) && action.payload.status >= 400) {
            // axiosBaseQuery puts the server's own message in `data` as a
            // string; fetchBaseQuery-backed APIs still deliver the parsed body.
            const { data } = action.payload;

            dispatch(
                addNotification({
                    type: 'error',
                    title: 'Error: ',
                    message: typeof data === 'string' ? data : data?.message || 'Request failed',
                })
            );
        }

        return next(action);
    };

const createMiddlewares = () => [
    unauthenticatedMiddleware,
    authApi.middleware,
    userInfoApi.middleware,
    artefactApi.middleware,
    jenkinsApi.middleware,
    versionApi.middleware,
    requestApi.middleware,
    magnumApi.middleware,
    reportApi.middleware,
    teamApi.middleware,
    runApi.middleware,
    neoMainApi.middleware,
    neoCognitoApi.middleware,
    neoServersApi.middleware,
    advancedReportApi.middleware,
];

export default createMiddlewares;
